import { render, staticRenderFns } from "./MessageEditor.vue?vue&type=template&id=6c0fb52c&"
import script from "./MessageEditor.vue?vue&type=script&lang=ts&"
export * from "./MessageEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports